import React, { useState, createContext } from 'react';

export const TicketContext = createContext();

function TicketContextComponent(props) {
  const [fsp, setFsp] = useState(
    localStorage.getItem('ticketListFSP') && JSON.parse(localStorage.getItem('ticketListFSP'))
      ? JSON.parse(localStorage.getItem('ticketListFSP'))
      : {
          page: 1,
          pageSize: 10,
          freeField: '',
          order: null,
          orderBy: null,
          distributorId: '',
          licenceDistributorId: '',
          includeNotAffectedTickets: true,
          licenceId: '',
          // objet fi user story
          types: [""],
          status: [""],
          severities: [""],
          creationDateBegin: null,
          creationDateEnd: null,
          closureDateBegin: null,
          closureDateEnd: null,
          assigneToUserId: null,
        },
  );

  return (
    <TicketContext.Provider
      value={{
        fsp,
        setFsp: fsp => {
          setFsp(fsp);
          if (localStorage.getItem('ticketListFSP')) {
            localStorage.setItem(
              'ticketListFSP',
              JSON.stringify({ ...JSON.parse(localStorage.getItem('ticketListFSP')), ...fsp }),
            );
          } else {
            localStorage.setItem('ticketListFSP', JSON.stringify({ ...fsp }));
          }
        },
      }}
    >
      {props.children}
    </TicketContext.Provider>
  );
}

export default TicketContextComponent;
